export interface AccessControlServiceConfig {
  restServer: string;
}

//  The following enum is temporary. There is a ticket to address fetching
//  the relations for an object type so that these can be loaded dynamically.
export enum AccessRelationship {
  owner = "Owner",  
  editor = "Editor",
  viewer = "Viewer",
}

export interface AccessGroup {
  user: string;
  user_type: string;
  label: string;
  initials: string;
}

export interface AccessTuple {
  user: string;
  user_type: string;
  relation: string;
  object_type: string;
  object_id: number;
}

export interface ObjectRelation {
  object_id: string;
  relations: AccessRelationship[]
}